<template>
    <div>
        <div class="kt-subheader kt-grid__item" id="kt_subheader">
            <div class="kt-container ">
                <div class="kt-subheader__main">
                    <h3 class="kt-subheader__title">Les Domaines Romes </h3>
                    <span class="kt-subheader__separator kt-hidden"></span>
                    <div class="kt-subheader__breadcrumbs">
                        <a href="#" class="kt-subheader__breadcrumbs-home"><i class="flaticon2-shelter"></i></a>
                        <span class="kt-subheader__breadcrumbs-separator"></span>
                        <a href="" class="kt-subheader__breadcrumbs-link">Tableau de bord </a>

                        <!-- <span class="kt-subheader__breadcrumbs-link kt-subheader__breadcrumbs-link--active">Active link</span> -->
                    </div>
                </div>
                <div class="kt-subheader__toolbar"></div>
            </div>
        </div>

        <div class="kt-container kt-grid__item kt-grid__item--fluid">
            <div class="row">
                <div class="col-md-8">
                    <div class="kt-portlet kt-portlet--height-fluid">
                        <div class="kt-portlet__head">
                            <div class="kt-portlet__head-label">
                                <h3 class="kt-portlet__head-title">Les {{resource.label}}s</h3>
                            </div>
                            <div class="kt-portlet__head-toolbar"></div>
                        </div>

                        <div class="kt-portlet__body">

                            <div class="row">
                                <div class="col-sm-4 text-left">
                                    <div class="kt-input-icon kt-input-icon--left">
                                        <input type="text" class="form-control" placeholder="Recherche..." v-model="searchTerm">
                                        <span class="kt-input-icon__icon kt-input-icon__icon--left">
                                            <span><i class="la la-search"></i></span>
                                        </span>
                                    </div>
                                </div>
                                <div class="col-sm-4"></div>
                                <div class="col-sm-4 text-right">
                                    <div class="dt-buttons btn-group">
                                        <button class="btn btn-secondary buttons-csv buttons-html5" tabindex="0" aria-controls="kt_table_1" type="button" @click="onCsv"><span>Excel</span></button>
                                        <button class="btn btn-secondary buttons-pdf buttons-html5" tabindex="0" aria-controls="kt_table_1" type="button"><span>PDF</span></button>
                                    </div>
                                </div>
                            </div>
                            <div class="kt-widget11">
                                <div class="kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--subtable kt-datatable--loaded">
                                    <table class="table table-striped">
                                        <thead>
                                        <tr>
                                            <th></th>
                                            <th v-for="field in resource.fields" :key="`${field.name}-th`">{{ field.label }}</th>
                                            <th>Actions</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(item, index) in items" :key="index">
                                            <td><span class="kt-badge kt-badge--danger kt-badge--dot"></span>&nbsp;<span class="kt-font-bold kt-font-danger">{{item.id}}</span></td>
                                            <td
                                                    v-for="field of resource.fields"
                                                    :key="`${field.name}-${item.id}`"
                                            >{{ item[field.name] }}</td>
                                            <td nowrap="">
                                                <router-link :to="{name: resource.name, params: {id: item.id}}" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="Show"><i class="la la-eye"></i></router-link>
                                                <a href="#" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="Edit" @click.prevent="onEdit(item)"><i class="la la-ellipsis-h"></i></a>
                                                <a href="#" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="Drop" @click.prevent="onDrop(item)"><i class="la la-trash"></i></a>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="kt-portlet kt-portlet--height-fluid">
                        <div class="kt-portlet__head">
                            <div class="kt-portlet__head-label">
                                <h3 class="kt-portlet__head-title">Ajouter un {{resource.label}}</h3>
                            </div>
                            <div class="kt-portlet__head-toolbar"></div>
                        </div>
                        <div class="kt-portlet__body">
                            <div class="kt-form__section kt-form__section--first">
                                <div class="alert alert-danger" v-show="error">{{error}}</div>
                                <form @submit.prevent="onAdd" class="kt-wizard-v2__form">
                                    <div v-for="field in resource.fields" :key="field.name" class="form-group">
                                        <label :for="field.name">{{ field.label }}</label>
                                        <input v-if="field.type === 'text'" :name="field.name" v-model="payload[field.name]" class="form-control" v-validate="{required: field.required}">
                                        <textarea v-else-if="field.type === 'textarea'" :name="field.name" v-uppercase v-model="payload[field.name]" class="form-control" v-validate="{required: field.required}"/>
                                        <span v-show="errors.has(field.name)" class="help-block text-danger">{{ errors.first(field.name) }}</span>
                                    </div>
                                    <div class="form-group form-group-last">
                                        <button type="submit" class="btn btn-bold btn-sm btn-label-brand">Valider</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import debounce from 'lodash/debounce';

    export default {
        props: {
            resource: {
                required: true,
                type: Object
            }
        },
        data: () => ({
            loading: false,
            error: "", searchTerm: null,
            payload: {},
        }),
        computed: {
            items() {
                return this.$store.getters[`${this.resource.name}/list`];
            }
        },
        watch: {
            searchTerm: {
                handler: debounce(function(val) {
                    if (val) this.onSearch()
                }, 1000)
            }
        },
        methods: {
            
            onAdd() {
                this.loading = true; this.error = '';
                this.$store.dispatch(`${this.resource.name}/add`, this.payload)
                    .then(() => this.$swal('Enregistré', 'Fichier ajouté avec succès.', 'success').then(() => this.payload = {}))
                    .catch(err => this.error = (err.data && (err.data.message || err.data.error_description)) || err.statusText)
                    .finally(() => this.loading = false);
            },
            onEdit(value) {
                this.payload = { ...value };
            },
            onDrop(value) {
                this.$swal({
                    title: 'Vous êtes sûr?',
                    text: 'Vous ne pouvez pas revenir en arrière!',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Oui supprimer!',
                    cancelButtonText: 'Non, garder!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then(r => {
                    if(r.value) this.$store.dispatch(`${this.resource.name}/del`, value).then(() => this.$swal('Supprimé', 'Suppression réussie!', 'success'))
                })
            },
            onSearch(offset) {
                let query = {};
                if(offset) query.page = offset -1;
                if(this.searchTerm) query.motcle = ('' + this.searchTerm).trim().toLowerCase();
                Object.assign(this.$route.query, query); //this.$router.push({query});
                this.$store.dispatch(`${this.resource.name}/all`, query);
            },
            onCsv() {}
        },
        created() {
            this.$store.dispatch(`${this.resource.name}/all`);
        }
    };
</script>

<style scoped></style>
